import Axios from "../utils/axiosInstance";
import axios from "axios";
// API for login with username and password for all roles

//  here add petrotec pre for each url whenever need



export const postLogin = (payload) => {
  return Axios.post("/auth/token", payload);
};



// export const postLogin = (data) => {
//   const formData = new URLSearchParams();
//   formData.append("username", data.username);
//   formData.append("password", data.password);

//   return Axios.post("/auth/token", formData, {
//     headers: {
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//   });
// };



// API for login with mobile no. for all roles
export const postLoginWithMobile = (payload) => {
  return Axios.post(`/sendOtp`, payload);
};

// API for otp verification of mobile no. login of all roles
export const postOtpVerification = (payload) => {
  return Axios.post(`/validateOtp`, payload);
};

// API for forgot password
export const postForgotPassword = (email) => {
  return Axios.post(`/forgotPassword?email=${email}`);
};

// API for otp post
export const sendOptForLogin = (payload) => {
  return Axios.post(`/sendotpforlogin?number=${payload.mobileNo}`);
};
// API for resete password
export const postResetPassword = (payload) => {
  return axios.post(`http://192.168.10.144:8080/petrotec/resetPassword`, payload);
};

export const sendOtp = (payload) => {
  return Axios.get(`/sendotp?number=${payload.mobileNo}`);
};

// export const validateOtp = (payload) => {
//   return Axios.post(`//validateOtp
// };